class TSSubscriptionV3 extends HTMLElement {
  constructor() {
    super();
    this.dynamicData = JSON.parse(this.querySelector("[dynamic-data]").textContent);
    this.variantsBlock = document.querySelector('[id^="variant-selects-"]');
    this.isSubscribe = false;
    window.addGiftToCart = false;
  }

  connectedCallback() {
    this.addEventListener("change", this.updateSellingPlan.bind(this))
    this.updateSellingPlan();
    
    const interval = setInterval(() => {this.updateSellingPlan()}, 500);
    setTimeout(() => {clearInterval(interval)}, 8000);
    
    if (this.variantsBlock) {
      this.variantsBlock.addEventListener("change", this.updateSellingPlan.bind(this))
    }
  }

  updateSellingPlan() {
    const currentOption = this.variantsBlock.querySelector("input:checked");
    const currentVariant = this.dynamicData.find(obj => obj.title === currentOption.value);

    const variantOptions = this.variantsBlock.querySelectorAll("input");

    variantOptions.forEach(variantOption => {
      this.isSubscribe = this.querySelector('[name="selling_type"]:checked').value === "subscribe"; 

      // Update variants info
      const variantOptionLabel = variantOption.nextElementSibling;
      const variantBasedOnOption = this.dynamicData.find(obj => obj.title === variantOption.value);
      const variantFirstSellPlan = variantBasedOnOption.sellingPlans[0];

      if (variantOption.checked && variantBasedOnOption.additionalImage) {
        const mainGalleryImage = document.querySelector('[id^="MediaGallery"] li img');
        const navGalleryImage = document.querySelector('[id^="GalleryThumbnails"] li img');
        const zoomGalleryImage = document.querySelector('[id^="ProductModal"] img');

        if (mainGalleryImage && navGalleryImage && zoomGalleryImage) {
          [mainGalleryImage, navGalleryImage, zoomGalleryImage].forEach(media => {
            media.removeAttribute("srcset");
            media.src = variantBasedOnOption.additionalImage;
          })
        }
      }

      const jarsQuantity = variantBasedOnOption.quantity;
      const variantPrice = this.isSubscribe ? variantFirstSellPlan.price : variantBasedOnOption.price;
      const variantSavings = this.isSubscribe ? variantFirstSellPlan.savings : variantBasedOnOption.savings;
      const pricePerJar = Math.floor(variantPrice / jarsQuantity);

      const subscriptionPriceEl = variantOptionLabel.querySelector(".subscription_price")
      const subscriptionSaveEl = variantOptionLabel.querySelector(".off-lable");

      const savingsTemplate = window.tsSubscriptionStrings.savingsTemplate;

      subscriptionPriceEl.textContent = Shopify.formatMoney(pricePerJar);

      if (variantSavings == 0) {
        subscriptionSaveEl.textContent = "";
      } else {
        subscriptionSaveEl.textContent = savingsTemplate.replace("{{ amount }}", variantSavings);
      }
    })

    // Update selling plan options
    const allPlansOptions = this.querySelectorAll(".ts-subscription-v3__plan");
    
    allPlansOptions.forEach((allPlansOption,index) => {
      const input = allPlansOption.querySelector("input");
      const label = allPlansOption.querySelector("span");

      input.value = currentVariant.sellingPlans[index].id;
      label.innerHTML = currentVariant.sellingPlans[index].name;
    })

    // Update price
    const onetimeOption = this.querySelector(".ts-subscription-v3__option--onetime");
    const onetimePriceElement = onetimeOption.querySelector(".ts-subscription-v3__option-price--main");
    const onetimeCompareElement = onetimeOption.querySelector(".ts-subscription-v3__option-price--compare");

    onetimePriceElement.textContent = currentVariant.priceMoney;
    onetimeCompareElement.textContent = currentVariant.compareMoney;
    
    if (currentVariant.compareMoney === currentVariant.priceMoney) {
      onetimeCompareElement.textContent = "";
    }

    const subscribeOption = this.querySelector(".ts-subscription-v3__option--subscribe");
    const subscribePriceElement = subscribeOption.querySelector(".ts-subscription-v3__option-price--main");
    const subscribeCompareElement = subscribeOption.querySelector(".ts-subscription-v3__option-price--compare");

    subscribePriceElement.textContent = currentVariant.sellingPlans[0].priceMoney;
    subscribeCompareElement.textContent = currentVariant.sellingPlans[0].compareMoney;

    //Update main price 
    // const priceWrapper = document.querySelector(".price-with-stock");
    // const priceCompare = priceWrapper.querySelector(".price__sale .price-item.price-item--regular");
    // const priceMain = priceWrapper.querySelector(".price__sale .price-item.price-item--sale");

    // if (this.isSubscribe) {
    //   priceCompare.textContent = currentVariant.sellingPlans[0].compareMoney;
    //   priceMain.textContent = currentVariant.sellingPlans[0].priceMoney;
    // } else {
    //   priceCompare.textContent = currentVariant.compareMoney;
    //   priceMain.textContent = currentVariant.priceMoney;
    // }

    // Update form 
    const productForm = document.querySelector("product-form form");

    if (!productForm.querySelector('[name="selling_plan"]')) {

      const sellingPlanInput = document.createElement('input');
      sellingPlanInput.type = 'hidden';
      sellingPlanInput.name = 'selling_plan';
      sellingPlanInput.value = '';

      productForm.prepend(sellingPlanInput);
    }

    const formPlan = productForm.querySelector('[name="selling_plan"]');

    formPlan.value = this.isSubscribe ? this.querySelector('[name="selling_plan"]:checked').value : "";

    if (this.isSubscribe && parseInt(currentVariant.title.match(/\d+/)[0]) !== 1) {
      window.addGiftToCart = true;
    } else {
      window.addGiftToCart = false;
    }
  }
}

customElements.define("ts-subscription-v3", TSSubscriptionV3);